/* Neko Toys — 作品 IP gallery search filter + IP room set-status badges +
   景品圖鑑 + 角色 chip filters. Tab switching + Swiper handled by neko-homepage.js.
   Vanilla JS, no dependencies. Loaded as defer. */
(function () {
  'use strict';

  // -------- 套裝 tab: sale-status badges --------
  // Reads data-status (collection-derived: selling / upcoming / finished) from
  // each product card, set by neko-homepage-product-card.liquid when
  // show_status_badge is true, and fills the [data-status-badge] pill. The
  // 倒數 N 日 countdown for upcoming sets uses data-sale-start. When a card has
  // no status collection it falls back to date math.
  var MS = 86400000;
  var today = new Date();
  today.setHours(0, 0, 0, 0);

  function parseIso(s) {
    if (!s) return null;
    var p = s.split('-');
    return p.length === 3 ? new Date(+p[0], +p[1] - 1, +p[2]) : null;
  }

  document.querySelectorAll('[data-status-badge]').forEach(function (badge) {
    var card = badge.closest('.neko-product-card');
    if (!card) return;
    var status = card.getAttribute('data-status') || '';
    var start = parseIso(card.getAttribute('data-sale-start') || '');
    var end = parseIso(card.getAttribute('data-sale-end') || '');
    var cls, txt;

    if (status === 'finished') {
      cls = 'neko-product-card__status--done';
      txt = '已結束';
    } else if (status === 'selling') {
      cls = 'neko-product-card__status--live';
      txt = '開賞中';
    } else if (status === 'upcoming') {
      cls = 'neko-product-card__status--soon';
      txt = (start && start > today) ? ('倒數 ' + Math.ceil((start - today) / MS) + ' 日') : '即將開售';
    } else if (start) {
      // No status collection → fall back to dates.
      if (start > today) {
        cls = 'neko-product-card__status--soon';
        txt = '倒數 ' + Math.ceil((start - today) / MS) + ' 日';
      } else if (!end || end >= today) {
        cls = 'neko-product-card__status--live';
        txt = '開賞中';
      } else {
        cls = 'neko-product-card__status--done';
        txt = '已結束';
      }
    } else {
      // Nothing to show — leave the pill hidden.
      return;
    }

    badge.className = 'neko-product-card__status ' + cls;
    badge.textContent = txt;
    badge.hidden = false;
  });

  // -------- Gallery: filter IP tiles by name --------
  var search = document.querySelector('[data-ipg-search]');
  if (search) {
    var tiles = Array.prototype.slice.call(document.querySelectorAll('[data-ipg-tile]'));
    var empty = document.querySelector('[data-ipg-empty]');
    search.addEventListener('input', function () {
      var q = search.value.trim().toLowerCase();
      var shown = 0;
      tiles.forEach(function (t) {
        var name = (t.getAttribute('data-name') || '').toLowerCase();
        var match = !q || name.indexOf(q) !== -1;
        t.hidden = !match;
        if (match) shown++;
      });
      if (empty) empty.hidden = shown !== 0 || !q;
    });
  }

  // -------- 景品圖鑑 tab: filter prize cards by prize_type chip --------
  var chipWrap = document.querySelector('[data-ipp-chips]');
  if (chipWrap) {
    var chips = Array.prototype.slice.call(chipWrap.querySelectorAll('[data-ipp-chip]'));
    var cards = Array.prototype.slice.call(document.querySelectorAll('[data-ipp-card]'));
    chipWrap.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-ipp-chip]');
      if (!chip) return;
      var type = chip.getAttribute('data-type') || '';
      chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); });
      cards.forEach(function (card) {
        var t = card.getAttribute('data-prize-type') || '';
        card.hidden = !(type === '' || t === type);
      });
    });
  }

  // -------- 角色 tab: filter prize cards by CHARACTER chip --------
  // Mirrors the prize-type filter but scoped to [data-chr-*] so the two don't
  // collide. A prize can feature multiple characters → data-chars is a
  // space-separated handle list; match the chip's handle as a whole word.
  var chrWrap = document.querySelector('[data-chr-chips]');
  if (chrWrap) {
    var chrChips = Array.prototype.slice.call(chrWrap.querySelectorAll('[data-chr-chip]'));
    var chrCards = Array.prototype.slice.call(document.querySelectorAll('[data-chr-card]'));
    chrWrap.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-chr-chip]');
      if (!chip) return;
      var ch = chip.getAttribute('data-char') || '';
      chrChips.forEach(function (c) { c.classList.toggle('is-active', c === chip); });
      chrCards.forEach(function (card) {
        var chars = ' ' + (card.getAttribute('data-chars') || '') + ' ';
        card.hidden = !(ch === '' || chars.indexOf(' ' + ch + ' ') !== -1);
      });
    });
  }
})();
